<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap partners-page row items-stretch">
        <div
            v-for="(partner, index) in partners"
            :key="index"
            class="partner-cover col-12"
            :class="{ 'col-md-6': !lastOddPartner(index) }"
        >
            <PartnerThumb :partner="partner"></PartnerThumb>
        </div>
    </div>
</template>

<script>
import PartnerThumb from '@/components/PartnerThumb'
import PageLoading from '@/components/PageLoading'
import partnersService from '@/services/modules/partners'

const loadingKeys = {
    fetchingPartners: 'fetching-partners',
}

export default {
    name: 'Partners',

    components: {
        PageLoading,
        PartnerThumb
    },

    data () {
        return {
            partners: [],
        }
    },

    computed: {
        isLoading () {
            return this.isFetchingPartners
        },

        isFetchingPartners () {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingPartners
            ).length
        },
    },

    async created () {
        await this.fetchPartners()
    },

    methods: {
        lastOddPartner (index) {
            return (index == this.partners.length - 1) && (!!(this.partners.length % 2))
        },

        async fetchPartners () {
            this.loadingAdd(loadingKeys.fetchingPartners)

            let parameters = {
                filter: {
                    active: true,
                    on_partners_page: true
                },
                orderBy: [
                    {
                        column: 'title',
                        direction: 'asc'
                    }
                ]
            }

            let response = await partnersService.partners.retrieve(parameters)

            if (response.status === 200) {
                this.partners = response.data.results
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', { message: response.data.message }),
                })
            }

            this.loadingRemove(loadingKeys.fetchingPartners)
        },
    },
}
</script>
